import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogClickGoods = (logging: AnyObject) => {
  const screen = useAtomicScreen();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (itemLogging: AnyObject) => {
      logAnalyticsEvent({
        name: 'CLICK_GOODS',
        analytics: {
          ...logging?.analytics,
          ...itemLogging?.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
      });
    },
    [logAnalyticsEvent, logging, screen],
  );
};
